import { Grid, Typography, TextField } from "@mui/material";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Tabs } from "../../../_constants/individualFields.constant";

const TechInfo = () => {
  const { allFields } = useSelector(
    (state) => state.individualField.initialFieldsList
  );

  const techInfoFields = useMemo(
    () =>
      allFields.filter(
        (field) => field.fieldDisplayPosition === Tabs.TECH_INFO
      ),
    [allFields]
  );

  return (
    <Grid container spacing={2} sx={{ px: 3, py: 2 }}>

      {techInfoFields.map((field) => (
        <Grid
          key={field.keyName}
          container
          size={{ xs: 12 }}   
          spacing={2}
        >
          <Grid
            size={{ xs: 12, sm: 3,md:2 }}
          >
            <Typography variant="body2" color="text.secondary">
              {field.label}
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, sm: 4 }}>
            <TextField
              fullWidth
              size="small"
              value={field.defaultValue ?? ""}
              disabled
            />
          </Grid>
        </Grid>
      ))}

    </Grid>
  );
};

export default TechInfo;
